import useSWRMutation from "swr/mutation";
import { ServicesURL } from "@utils/utilsApi";
import { fetcher } from "src/services/config";
import { MethodType } from "src/services/type";

interface DeleteEditionEnrollmentArgs {
  corporateId: string | number;
  objectId: string | number;
  studentEid: string | number;
  editionId: string | number;
}

export const useDeleteEditionEnrollment = () => {
  const { trigger, isMutating } = useSWRMutation(
    ServicesURL.getEnrollEdition,
    (url: string, { arg }: { arg: DeleteEditionEnrollmentArgs }) =>
      fetcher<any>(
        `${url}?corporateId=${arg.corporateId}&objectId=${arg.objectId}&studentEid=${arg.studentEid}&editionId=${arg.editionId}`,
        MethodType.DELETE,
      ),
  );

  return { deleteEnrollment: trigger, isDeleting: isMutating };
};
